export default __webpack_public_path__ + "static/first-step-cta-back-789002e142fcf8ed5f7629cd91a50e4d.webp";